import React from 'react'

export default () =>
  <div className="l-wrapper">
    <hr className="separator-hr" />
  </div>
